import _ from 'lodash'
import React, { useEffect, useState, useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import classNames from 'classnames'
import { routeUtils } from '@ud/admin-framework'
import { appStore } from '../../stores/appStore'
import { uaaCenter } from '../../uaaCenter'
import { useMessageHandler } from './useMessageHandler'
import { activeWatcher } from '../../utils'
import './OtherSysContainer.less'

const OtherSysContainer: React.FC<IOtherSysContainerProps> = (props) => {
  const iframeRef = useRef<any>()
  let [url, setUrl] = useState('')
  const changeUrl = (newUrl: string) => {
    if (newUrl) {
      appStore.showCenterHeader = appStore.showCenterSidebar = newUrl.indexOf('closeParent=true') == -1
      let u = new URL(newUrl)
      let params = new URLSearchParams(u.search)
      if (params.has('v')) {
        params.set('v', new Date().getTime().toString())
      } else {
        params.append('v', new Date().getTime().toString())
      }
      newUrl = `${u.origin}${u.pathname}?${params.toString()}${u.hash}`
    }
    setUrl(newUrl)

  }

  useMessageHandler({ enable: true, onChangeUrl: changeUrl })

  useEffect(() => {
    let lastVisit = uaaCenter.getLastVisit()
    let code = props.match.params.code

    const pagePath = props.match.params.pagePath
    const stateParams: any = props.history.location.state || {}
    const pathHash = pagePath ? ('#' + decodeURIComponent(pagePath)) : ''
    const searchString = routeUtils.objectToSearchString(stateParams)

    if (lastVisit && lastVisit.systemCode == code) {
      changeUrl(lastVisit.url)
    } else {
      const systemUrl = appStore.myUserData.webUrls[code] + searchString + pathHash
      changeUrl(systemUrl)
    }
  }, [])

  useEffect(() => {
    let { code, pagePath } = props.match.params
    const stateParams: any = props.history.location.state || {}

    const pathHash = pagePath ? ('#' + decodeURIComponent(pagePath)) : ''
    const searchString = routeUtils.objectToSearchString(stateParams)
    const systemUrl = appStore.myUserData.webUrls[code] + searchString + pathHash
    changeUrl(systemUrl)
  }, [props.match.params.code, props.match.params.pagePath])


  useEffect(() => {
    otherSysWatcherActive()
    return () => {
      try {
        const iframeNode = iframeRef.current
        iframeNode?.contentWindow?.removeEventListener('mousemove', handleActive)
        iframeNode?.contentWindow?.removeEventListener('keydown', handleActive)
      } catch (error) {
        console.log(`clear otherSysWatcherActive fail`, error)
      }
    }
  }, [url])

  const otherSysWatcherActive = () => {
    const iframeNode = iframeRef.current
    if (iframeNode) {
      iframeNode.onload = function () {
        try {
          iframeNode?.contentWindow?.addEventListener('mousemove', handleActive)
          iframeNode?.contentWindow?.addEventListener('keydown', handleActive)
        } catch (error) {
          console.log(`uaa activeWatcher 子系统监听 启动失败`, error)
        }
      }
    }
  }

  const handleActive = function () {
    activeWatcher.handleActive()
  }

  return (
    <iframe title={props.match.params.code} ref={(ref) => iframeRef.current = ref} src={url} className={classNames('other-sys-container', 'other-sys-' + props.match.params.code)} />
  )
}

interface IOtherSysContainerProps extends RouteComponentProps<{
  code: string
  pagePath: string
}> {
}

export default OtherSysContainer
